// extracted by mini-css-extract-plugin
export default {"synth":"Synth_synth__wlbyB","globalParamWrapper":"Synth_globalParamWrapper__BENqv"};